import {
  Avatar,
  FormControl,
  InputAdornment,
  InputLabel,
  Stack,
  TextField,
  Tooltip,
  Box,
  Button,
  Typography,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import AddIcon from "@mui/icons-material/Add";
import React, { useState } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import { s3baseUrl } from "src/config/config";
import Label from "src/components/Label";
import ToshowExercise from "./component/modalToshowExercise";
import ModalToShowAnExerciseInfo from "../Workout/components/ModalToShowAnExerciseInfo";
import { super_set_item_2 } from "src/utils/constant";

const WorkoutExercisesUIClient = ({
  addArray,
  setaddArray,
  setModalChangeExe,
  message,
}) => {
  const [detailsData, setDetailsData] = useState("");
  const [exerIndex, setExerIndex] = useState("");
  const [openDetails, setOpenDetails] = useState(false);
  const [isExerciseForSuperSet, setIsExerciseForSuperSet] = useState(false);
  const [openSingleExerciseInfo, setOpenSingleExerciseInfo] = useState(false);
  const [singleExerciseInfo, setSingleExerciseInfo] = useState("");

  const handleArrow = (value, index) => {
    const list = [...addArray];
    list[index]["open"] = value;
    setaddArray(list);
  };

  const handleArrowSuperSet = (value, mainindex, exerIndex) => {
    const list = [...addArray];
    list[mainindex]["superSet"][exerIndex]["open"] = value;

    setaddArray(list);
  };

  const handleChange = (e, index, index1) => {
    const { name, value } = e.target;
    const list = [...addArray];
    console.log(list, "sdflkjsdak", list[index]["set"][index1][name]);
    list[index]["set"][index1][name] = value;
    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleChangeSuperSetDes = (e, index, index1) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[index]["superSet"][index1][name] = value;
    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleChangeDes = (e, index) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[index][name] = value;
    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleChangeSuperSet = (e, mainindex, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[mainindex]["superSet"][exerIndex]["set"][setIndex][name] = value;
    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleAddSetCount = (index) => {
    const list = [...addArray];
    const name = "superset_sets";
    const value = parseInt(list[index].superset_sets) + 1;
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));

    list[index][name] = targetValue;

    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;

      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;

        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push({
            ...super_set_item_2,
          });
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });

    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleMinusSetCount = (index) => {
    const list = [...addArray];
    const name = "superset_sets";
    const value = parseInt(list[index].superset_sets) - 1;
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));
    list[index][name] = targetValue;
    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;

      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;

        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push({
            ...super_set_item_2,
          });
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });
    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleChangeSuperSetCount = (e, index) => {
    const { name, value } = e.target;
    const list = [...addArray];
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));
    list[index][name] = targetValue;
    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;
      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;
        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push({
            ...super_set_item_2,
          });
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });
    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleSupersetExerciseList = (mainIndex, exerInde) => {
    setDetailsData(mainIndex);
    setExerIndex(exerInde);
    setIsExerciseForSuperSet(true);
  };

  const handleSelectExercise = (value) => {
    const list = [...addArray];
    list[detailsData]["exercise"] = value;
    list[detailsData]["description"] = value?.instructions;

    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleSelectSupersetExercise = (value) => {
    const list = [...addArray];
    list[detailsData]["superSet"][exerIndex]["exercise"] = value;
    list[detailsData]["superSet"][exerIndex]["description"] =
      value?.instructions;
    list[detailsData]["superSet"][exerIndex]["open"] = true;

    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleClickOpen = async (exercise) => {
    setSingleExerciseInfo(exercise);
    setOpenSingleExerciseInfo(true);
  };

  return (
    <div className="container-fluid">
      {openDetails && (
        <ToshowExercise
          open={openDetails}
          setOpen={setOpenDetails}
          handleChange={handleSelectExercise}
        />
      )}
      {openSingleExerciseInfo && (
        <ModalToShowAnExerciseInfo
          open={openSingleExerciseInfo}
          setOpen={setOpenSingleExerciseInfo}
          Id={singleExerciseInfo}
        />
      )}
      {isExerciseForSuperSet && (
        <ToshowExercise
          open={isExerciseForSuperSet}
          setOpen={setIsExerciseForSuperSet}
          handleChange={handleSelectSupersetExercise}
        />
      )}
      <div className="mt-2 ">
        <div className="characters">
          {addArray?.map((data, mainindex) => {
            return (
              <>
                {data?.superSet && data?.superSet.length > 0 ? (
                  <>
                    <div
                      style={{ position: "relative" }}
                      className="workout-Superset-card my-2"
                    >
                      <Box>
                        <div className="d-flex align-items-start justify-content-between ">
                          <div className="d-flex align-items-center w-100  mb-2">
                            <div>Superset of</div>
                            <div className="ms-2 cross-icon ">
                              <RemoveCircleIcon
                                onClick={() => handleMinusSetCount(mainindex)}
                                className="diary-icon-plus-minus"
                              />
                            </div>

                            <TextField
                              id="outlined-basic"
                              size="small"
                              variant="outlined"
                              placeholder="Sets"
                              type="number"
                              value={data.superset_sets}
                              name="superset_sets"
                              disabled
                              onChange={(e) =>
                                handleChangeSuperSetCount(e, mainindex)
                              }
                              InputLabelProps={{
                                className: "textfiels-input-label",
                                shrink: true,
                                style: { fontSize: "14px" },
                              }}
                              InputProps={{
                                className: "textfiels-input-value",
                                style: { fontSize: "13px", padding: "0" },
                              }}
                              sx={{
                                mx: 1,
                                borderRadius: "5px",
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                fontSize: "13px",
                                "& input": {
                                  padding: "3px 5px",
                                  textAlign: "center",
                                },
                                width: "4%",
                              }}
                            />

                            <div className=" cross-icon me-2">
                              <AddCircleIcon
                                onClick={() => handleAddSetCount(mainindex)}
                                className="diary-icon-plus-minus"
                              />
                            </div>
                            <div>sets</div>
                          </div>
                        </div>
                        <div className=" mb-2 ">
                          {data?.superSet?.map((exerData, exerIndex) => (
                            <div className="d-flex  workout-set-card">
                              <Box
                                sx={{
                                  position: "relative",
                                  width: "100%",
                                }}
                              >
                                <div className="d-flex align-items-center ">
                                  <TextField
                                    id="outlined-basic"
                                    variant="outlined"
                                    placeholder="Exercise"
                                    value={exerData?.exercise?.title}
                                    name="Exercise"
                                    onClick={() =>
                                      handleSupersetExerciseList(
                                        mainindex,
                                        exerIndex,
                                      )
                                    }
                                    InputLabelProps={{
                                      className: "textfiels-input-label",
                                      shrink: true,
                                      style: { fontSize: "14px" },
                                    }}
                                    label="Exercise"
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: {
                                        fontSize: "13px",
                                        paddingLeft: "6px",
                                      },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          {exerData?.exercise?.image
                                            ?.thumbnail_3 && (
                                            <Avatar
                                              sx={{ borderRadius: "5px" }}
                                              alt="User Image"
                                              src={
                                                s3baseUrl +
                                                exerData?.exercise?.image
                                                  ?.thumbnail_3
                                              }
                                            />
                                          )}
                                        </InputAdornment>
                                      ),
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <div style={{ fontSize: "16px" }}>
                                            {exerData?.exercise ? (
                                              <EditIcon
                                                fontSize="12px"
                                                sx={{ opacity: 0.5 }}
                                              />
                                            ) : (
                                              <AddIcon sx={{ opacity: 0.5 }} />
                                            )}
                                          </div>
                                        </InputAdornment>
                                      ),
                                      inputProps: {
                                        readOnly: true, // Disable editing
                                      },
                                    }}
                                    sx={{
                                      borderRadius: "5px",

                                      fontSize: "13px",
                                      width: "50%",
                                    }}
                                  />
                                  <div className="d-flex align-items-center mx-1">
                                    <div className="text-center">
                                      {!exerData?.open ? (
                                        <KeyboardArrowDownIcon
                                          sx={{
                                            cursor: "pointer",
                                            opacity: 0.5,
                                            fontSize: "20px",
                                          }}
                                          onClick={() => {
                                            handleArrowSuperSet(
                                              true,
                                              mainindex,
                                              exerIndex,
                                            );
                                          }}
                                        />
                                      ) : (
                                        <KeyboardArrowUpIcon
                                          sx={{
                                            cursor: "pointer",
                                            opacity: 0.5,
                                            fontSize: "20px",
                                          }}
                                          onClick={() => {
                                            handleArrowSuperSet(
                                              false,
                                              mainindex,
                                              exerIndex,
                                            );
                                          }}
                                        />
                                      )}
                                    </div>
                                    <Typography
                                      variant="body2"
                                      sx={{ opacity: 0.6 }}
                                    >
                                      {` Sets ${exerData?.set?.length}`}
                                    </Typography>
                                  </div>
                                </div>
                                {exerData?.open && (
                                  <TextField
                                    id="outlined-basic"
                                    size="small"
                                    variant="outlined"
                                    placeholder="Instructions"
                                    label="Instructions"
                                    type="number"
                                    value={exerData.description}
                                    name="description"
                                    multiline
                                    rows={2}
                                    onChange={(e) =>
                                      handleChangeSuperSetDes(
                                        e,
                                        mainindex,
                                        exerIndex,
                                      )
                                    }
                                    InputLabelProps={{
                                      className: "textfiels-input-label",
                                      shrink: true,
                                      style: { fontSize: "14px" },
                                    }}
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: { fontSize: "14px" },
                                    }}
                                    sx={{
                                      borderRadius: "5px",
                                      mt: 2,
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {exerData?.open &&
                                  exerData?.set?.map((item, setIndex) => (
                                    <div className="d-flex align-items-center my-3 workout-card-inset">
                                      <Stack
                                        direction="row"
                                        spacing={1}
                                        alignItems="center"
                                        justifyContent="start"
                                      >
                                        <Label
                                          variant={"ghost"}
                                          sx={{ padding: "25px 4px" }}
                                        >
                                          {setIndex + 1}
                                        </Label>
                                        <CloseIcon sx={{ opacity: 0.3 }} />
                                        <TextField
                                          id="outlined-basic"
                                          size="small"
                                          variant="outlined"
                                          placeholder="0"
                                          type="number"
                                          value={item?.time}
                                          name="time"
                                          onChange={(e) => {
                                            handleChangeSuperSet(
                                              e,
                                              mainindex,
                                              exerIndex,
                                              setIndex,
                                            );
                                          }}
                                          InputLabelProps={{
                                            className: "textfiels-input-label",
                                            shrink: true,
                                            style: {
                                              fontSize: "14px",
                                            },
                                          }}
                                          label="Duration"
                                          InputProps={{
                                            className: "textfiels-input-value",
                                            style: {
                                              fontSize: "13px",
                                              paddingRight: 0,
                                            },
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <Select
                                                  id="select-option"
                                                  variant="outlined"
                                                  size="small"
                                                  name="timeType"
                                                  value={item?.timeType}
                                                  label="Weight Type"
                                                  inputProps={{
                                                    style: {
                                                      padding: 0,
                                                    },
                                                  }}
                                                  onChange={(e) => {
                                                    handleChangeSuperSet(
                                                      e,
                                                      mainindex,
                                                      exerIndex,
                                                      setIndex,
                                                    );
                                                  }}
                                                  sx={{
                                                    "& legend": {
                                                      display: "none",
                                                    },
                                                    "& fieldset": {
                                                      top: 0,
                                                    },
                                                    fontSize: "13px",
                                                    border: "none",
                                                    "& fieldset": {
                                                      border: "none",
                                                    },
                                                    "& .MuiOutlinedInput-input":
                                                      {
                                                        padding: 0,
                                                      },
                                                  }}
                                                >
                                                  <MenuItem value="c">
                                                    Min
                                                  </MenuItem>
                                                  <MenuItem value="km">
                                                    sec
                                                  </MenuItem>
                                                </Select>
                                              </InputAdornment>
                                            ),
                                          }}
                                          sx={{
                                            borderRadius: "5px",
                                            fontSize: "13px",
                                            width: "20%",
                                          }}
                                        />
                                        <TextField
                                          id="outlined-basic"
                                          size="small"
                                          variant="outlined"
                                          placeholder="Reps"
                                          type="number"
                                          label="Reps"
                                          value={item?.reps}
                                          name="reps"
                                          onChange={(e) => {
                                            handleChangeSuperSet(
                                              e,
                                              mainindex,
                                              exerIndex,
                                              setIndex,
                                            );
                                          }}
                                          InputLabelProps={{
                                            className: "textfiels-input-label",
                                            shrink: true,
                                            style: { fontSize: "14px" },
                                          }}
                                          InputProps={{
                                            className: "textfiels-input-value",
                                            style: { fontSize: "13px" },
                                          }}
                                          sx={{
                                            borderRadius: "5px",
                                            fontSize: "13px",
                                            width: "13%",
                                          }}
                                        />
                                        <TextField
                                          id="outlined-basic"
                                          size="small"
                                          variant="outlined"
                                          placeholder="Max Reps"
                                          type="number"
                                          label="Max Reps"
                                          value={item?.maxReps}
                                          name="maxReps"
                                          onChange={(e) => {
                                            handleChangeSuperSet(
                                              e,
                                              mainindex,
                                              exerIndex,
                                              setIndex,
                                            );
                                          }}
                                          InputLabelProps={{
                                            className: "textfiels-input-label",
                                            shrink: true,
                                            style: { fontSize: "14px" },
                                          }}
                                          InputProps={{
                                            className: "textfiels-input-value",
                                            style: { fontSize: "13px" },
                                          }}
                                          sx={{
                                            borderRadius: "5px",
                                            fontSize: "13px",
                                            width: "13%",
                                          }}
                                        />
                                        <TextField
                                          id="outlined-basic"
                                          size="small"
                                          variant="outlined"
                                          placeholder="Watts"
                                          type="number"
                                          label="Watts"
                                          value={item?.watts}
                                          name="watts"
                                          onChange={(e) => {
                                            handleChangeSuperSet(
                                              e,
                                              mainindex,
                                              exerIndex,
                                              setIndex,
                                            );
                                          }}
                                          InputLabelProps={{
                                            className: "textfiels-input-label",
                                            shrink: true,
                                            style: { fontSize: "14px" },
                                          }}
                                          InputProps={{
                                            className: "textfiels-input-value",
                                            style: { fontSize: "13px" },
                                          }}
                                          sx={{
                                            borderRadius: "5px",
                                            fontSize: "13px",
                                            width: "13%",
                                          }}
                                        />
                                        <TextField
                                          sx={{
                                            borderRadius: "5px",
                                            paddingRight: 0,
                                            width: "45%",
                                          }}
                                          size="small"
                                          id="custom-input"
                                          variant="outlined"
                                          placeholder="Weight"
                                          name="weight"
                                          label="Weight"
                                          value={item.weight}
                                          onChange={(e) => {
                                            handleChangeSuperSet(
                                              e,
                                              mainindex,
                                              exerIndex,
                                              setIndex,
                                            );
                                          }}
                                          type="number"
                                          InputLabelProps={{
                                            className: "textfiels-input-label",
                                            shrink: true,
                                            style: { fontSize: "14px" },
                                          }}
                                          InputProps={{
                                            className: "textfiels-input-value",
                                            style: {
                                              fontSize: "13px",
                                              paddingRight: 0,
                                            },
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <Select
                                                  id="select-option"
                                                  variant="outlined"
                                                  size="small"
                                                  name="weightType"
                                                  value={item?.weightType}
                                                  label="Weight Type"
                                                  onChange={(e) => {
                                                    handleChangeSuperSet(
                                                      e,
                                                      mainindex,
                                                      exerIndex,
                                                      setIndex,
                                                    );
                                                  }}
                                                  sx={{
                                                    "& legend": {
                                                      display: "none",
                                                    },
                                                    "& fieldset": { top: 0 },
                                                    fontSize: "13px",
                                                    border: "none",
                                                    "& fieldset": {
                                                      border: "none",
                                                    },
                                                  }}
                                                >
                                                  <MenuItem value="1rm">
                                                    % 1RM
                                                  </MenuItem>
                                                  <MenuItem value="body_weight">
                                                    % BW
                                                  </MenuItem>
                                                  <MenuItem value="kg">
                                                    KG
                                                  </MenuItem>
                                                  <MenuItem value="lb">
                                                    Pound
                                                  </MenuItem>
                                                  <MenuItem value="poods">
                                                    Poods
                                                  </MenuItem>
                                                </Select>
                                              </InputAdornment>
                                            ),
                                          }}
                                        />
                                        <TextField
                                          sx={{
                                            borderRadius: "5px",
                                            paddingRight: 0,
                                            width: "45%",
                                          }}
                                          size="small"
                                          id="custom-input"
                                          variant="outlined"
                                          placeholder="Distance"
                                          name="distance"
                                          label="Distance"
                                          value={item?.distance}
                                          onChange={(e) => {
                                            handleChangeSuperSet(
                                              e,
                                              mainindex,
                                              exerIndex,
                                              setIndex,
                                            );
                                          }}
                                          type="number"
                                          InputLabelProps={{
                                            className: "textfiels-input-label",
                                            shrink: true,
                                            style: { fontSize: "14px" },
                                          }}
                                          InputProps={{
                                            className: "textfiels-input-value",
                                            style: {
                                              fontSize: "13px",
                                              paddingRight: 0,
                                            },
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <Select
                                                  id="select-option"
                                                  variant="outlined"
                                                  size="small"
                                                  name="distanceType"
                                                  value={item?.distanceType}
                                                  label="Weight Type"
                                                  onChange={(e) => {
                                                    handleChangeSuperSet(
                                                      e,
                                                      mainindex,
                                                      exerIndex,
                                                      setIndex,
                                                    );
                                                  }}
                                                  sx={{
                                                    "& legend": {
                                                      display: "none",
                                                    },
                                                    "& fieldset": { top: 0 },
                                                    fontSize: "13px",
                                                    border: "none",
                                                    "& fieldset": {
                                                      border: "none",
                                                    },
                                                  }}
                                                >
                                                  <MenuItem value="m">
                                                    Meter
                                                  </MenuItem>
                                                  <MenuItem value="km">
                                                    KM
                                                  </MenuItem>
                                                  <MenuItem value="mi">
                                                    Mile
                                                  </MenuItem>
                                                </Select>
                                              </InputAdornment>
                                            ),
                                          }}
                                        />
                                        <TextField
                                          id="outlined-basic"
                                          size="small"
                                          variant="outlined"
                                          placeholder="0"
                                          type="number"
                                          value={item?.rest}
                                          name="rest"
                                          onChange={(e) => {
                                            handleChangeSuperSet(
                                              e,
                                              mainindex,
                                              exerIndex,
                                              setIndex,
                                            );
                                          }}
                                          InputLabelProps={{
                                            className: "textfiels-input-label",
                                            shrink: true,
                                            style: { fontSize: "14px" },
                                          }}
                                          label="Rest"
                                          InputProps={{
                                            className: "textfiels-input-value",
                                            style: {
                                              fontSize: "13px",
                                              paddingRight: 0,
                                            },
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <Select
                                                  id="select-option"
                                                  variant="outlined"
                                                  size="small"
                                                  name="restType"
                                                  value={item?.restType}
                                                  label="Weight Type"
                                                  inputProps={{
                                                    style: {
                                                      padding: 0,
                                                    },
                                                  }}
                                                  onChange={(e) => {
                                                    handleChangeSuperSet(
                                                      e,
                                                      mainindex,
                                                      exerIndex,
                                                      setIndex,
                                                    );
                                                  }}
                                                  sx={{
                                                    "& legend": {
                                                      display: "none",
                                                    },
                                                    "& fieldset": {
                                                      top: 0,
                                                    },
                                                    fontSize: "13px",
                                                    border: "none",
                                                    "& fieldset": {
                                                      border: "none",
                                                    },
                                                    "& .MuiOutlinedInput-input":
                                                      {
                                                        padding: 0,
                                                      },
                                                  }}
                                                >
                                                  <MenuItem value="c">
                                                    Min
                                                  </MenuItem>
                                                  <MenuItem value="km">
                                                    sec
                                                  </MenuItem>
                                                </Select>
                                              </InputAdornment>
                                            ),
                                          }}
                                          sx={{
                                            borderRadius: "5px",
                                            fontSize: "13px",
                                            width: "20%",
                                          }}
                                        />
                                      </Stack>
                                    </div>
                                  ))}
                              </Box>
                            </div>
                          ))}
                        </div>
                      </Box>
                    </div>
                  </>
                ) : (
                  <div className="d-flex my-2 workout-set-card w-100">
                    <Box
                      sx={{
                        position: "relative",
                        width: "100%",
                      }}
                    >
                      <div className="row  ">
                        <div
                          className={`col-sm-12 ${"col-md-7"} col-lg-6 d-flex align-items-center p-0 mt-2 mt-md-0 mt-lg-0`}
                        >
                          {data?.is_modified && (
                            <span
                              style={{
                                position: "absolute",
                                top: "-32px",
                                justifyContent: "center",
                                zIndex: "1",
                                left: "-38px",
                                transform: "rotate(-53deg)",
                              }}
                            >
                              <Chip
                                label={"Modified"}
                                variant="contained"
                                color={"error"}
                                sx={{
                                  fontSize: "10px",
                                  height: "auto",
                                  width: "auto",
                                }}
                              />
                            </span>
                          )}
                          <div className="exercise-label-box">
                            <span className="outer-label">Exercise</span>
                            <div className="d-flex align-items-center justify-content-between">
                              <Tooltip
                                placement="top"
                                touch="on"
                                title={message}
                              >
                                <div className="w-100">
                                  <div className="exercise-label w-100">
                                    <div className="d-flex align-items-center">
                                      {data?.exercise?.image?.thumbnail_3 && (
                                        <Avatar
                                          sx={{
                                            borderRadius: "5px",
                                          }}
                                          alt="User Image"
                                          src={
                                            s3baseUrl +
                                            data?.exercise?.image?.thumbnail_3
                                          }
                                        />
                                      )}
                                      <div className="label-text ms-1">
                                        {data?.exercise?.title
                                          ? data?.exercise?.title
                                          : ""}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Tooltip>
                              <div className="exercise-action">
                                <div style={{ fontSize: "16px" }}>
                                  {data?.exercise ? (
                                    <div>
                                      <InfoIcon
                                        onClick={() =>
                                          handleClickOpen(data?.exercise?._id)
                                        }
                                        className="d-block"
                                        fontSize="14px"
                                        sx={{
                                          opacity: 0.5,
                                          cursor: "pointer",
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <AddIcon
                                      sx={{
                                        opacity: 0.5,
                                        cursor: "pointer",
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <Button
                            sx={{ textTransform: "inherit" }}
                            size="small"
                            color="primary"
                            variant="contained"
                            className="d-flex align-items-center ms-2 small-contained-dialog-button"
                            onClick={() => {
                              handleArrow(
                                !data?.open ? true : false,
                                mainindex,
                              );
                            }}
                          >
                            {!data?.open ? (
                              <KeyboardArrowDownIcon
                                sx={{
                                  cursor: "pointer",
                                  fontSize: "20px",
                                }}
                              />
                            ) : (
                              <KeyboardArrowUpIcon
                                sx={{
                                  cursor: "pointer",
                                  fontSize: "20px",
                                }}
                              />
                            )}

                            <Typography
                              variant="body2"
                              sx={{
                                whiteSpace: "nowrap",
                              }}
                            >
                              {` Sets ${data?.set?.length}`}
                            </Typography>
                          </Button>
                        </div>
                      </div>
                      {data?.open && (
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="Instructions"
                          label="Instructions"
                          type="number"
                          value={data.description}
                          name="description"
                          multiline
                          rows={2}
                          onChange={(e) => handleChangeDes(e, mainindex)}
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: { fontSize: "14px" },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            readOnly: true,
                            style: { fontSize: "14px" },
                          }}
                          sx={{
                            borderRadius: "5px",

                            mt: 2,
                            width: "100%",
                          }}
                        />
                      )}
                      {data?.open &&
                        data?.set?.map((item, index1) => (
                          <Tooltip placement="top" title={message}>
                            <div className="d-flex align-items-center my-3 workout-card-inset">
                              <div className="row w-100">
                                {data.parameters.includes("Vdot") && (
                                  <>
                                    {
                                      <div
                                        className={`col-12 col-md-2 col-lg-1 pe-0 py-1`}
                                      >
                                        <TextField
                                          id="outlined-basic"
                                          size="small"
                                          variant="outlined"
                                          placeholder="0"
                                          type="number"
                                          label="Auto Pacer"
                                          value={item?.vdot}
                                          name="vdot"
                                          InputLabelProps={{
                                            className: "textfiels-input-label",
                                            shrink: true,
                                            style: { fontSize: "14px" },
                                          }}
                                          InputProps={{
                                            className: "textfiels-input-value",
                                            style: {
                                              fontSize: "13px",
                                              paddingLeft: "0px",
                                              paddingRight: "5px",
                                            },
                                            readOnly: true,
                                          }}
                                          sx={{
                                            borderRadius: "5px",
                                            fontSize: "13px",
                                            width: "100%",
                                            marginTop: "5px",
                                          }}
                                        />
                                      </div>
                                    }
                                    <div
                                      className={`col-12 col-md-5 ${
                                        item?.race_type == "el"
                                          ? "col-lg-3"
                                          : "col-lg-3"
                                      } pe-0 py-1`}
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        variant="outlined"
                                        label="Type & Distance"
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        readOnly={true}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingLeft: "0px",
                                            paddingRight: "0px",

                                            justifyContent: "center",
                                          },
                                          readOnly: true,
                                          endAdornment: (
                                            <InputAdornment
                                              position="end"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="race_type"
                                                value={item?.race_type}
                                                label="Weight Type"
                                                inputProps={{
                                                  style: {
                                                    padding: 0,
                                                  },
                                                }}
                                                readOnly={true}
                                                onChange={(e) => {
                                                  handleChangeVdotDistance(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  );
                                                }}
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": {
                                                    top: 0,
                                                  },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: 0,
                                                  },
                                                }}
                                              >
                                                <MenuItem value="el">
                                                  Easy/Long
                                                </MenuItem>
                                                <MenuItem value="c">
                                                  Compromised
                                                </MenuItem>
                                                <MenuItem value="t">
                                                  Threshold
                                                </MenuItem>
                                                <MenuItem value="i">
                                                  Interval
                                                </MenuItem>
                                                <MenuItem value="r">
                                                  Repitition
                                                </MenuItem>
                                              </Select>

                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="pace_type"
                                                value={item?.pace_type}
                                                label="Weight Type"
                                                inputProps={{
                                                  style: {
                                                    padding: 0,
                                                  },
                                                }}
                                                readOnly={true}
                                                onChange={(e) => {
                                                  handleChangeVdotPaceType(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  );
                                                }}
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": {
                                                    top: 0,
                                                  },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: 0,
                                                  },
                                                }}
                                              >
                                                {item?.optionsType?.map(
                                                  (option) => {
                                                    return (
                                                      <MenuItem
                                                        key={option?.key}
                                                        value={option?.key}
                                                      >
                                                        {option?.title}
                                                      </MenuItem>
                                                    );
                                                  },
                                                )}
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",

                                          marginTop: "5px",
                                          "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                            {
                                              width: "0px !important",
                                              padding: "9px 0px !important",
                                            },
                                          "& .css-1nuss9t": {
                                            width: "0px !important",
                                            padding: "9px 0px !important",
                                          },

                                          width: "100%",
                                        }}
                                      />
                                    </div>
                                    item?.race_type == "el" ? (
                                    <div
                                      className={`col-12 col-md-3 col-lg-2 pe-0 py-1`}
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        variant="outlined"
                                        label={getPaceText(item?.pace_type)}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingLeft: "0px",
                                            paddingRight: "0px",

                                            justifyContent: "center",
                                          },
                                          readOnly: true,
                                          endAdornment: (
                                            <InputAdornment
                                              position="end"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <TextField
                                                id="outlined-basic-minutes"
                                                type="number"
                                                size="small"
                                                placeholder="Min"
                                                name="pace"
                                                readOnly="true"
                                                value={formatWithLeadingZeros(
                                                  Math.floor(item?.pace / 60),
                                                )}
                                                onChange={(e) =>
                                                  handleMinutesChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  )
                                                }
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                  readOnly: true,
                                                }}
                                                sx={{
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& input": {
                                                    textAlign: "center",
                                                    padding: "0px",
                                                  },
                                                  width: "100%",
                                                }}
                                              />
                                              <div className="fs-6 fw-semibold ms-1 ">
                                                :
                                              </div>

                                              <TextField
                                                id="outlined-basic-seconds"
                                                type="number"
                                                size="small"
                                                placeholder="Sec"
                                                name="pace"
                                                value={formatWithLeadingZeros(
                                                  item?.pace % 60,
                                                )}
                                                onChange={(e) =>
                                                  handleSecondsChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  )
                                                }
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                  readOnly: true,
                                                }}
                                                sx={{
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& input": {
                                                    textAlign: "center",
                                                    padding: "0px",
                                                  },
                                                  width: "100%",
                                                }}
                                              />

                                              <div className="fs-6 fw-semibold ms-1 me-1 ">
                                                -
                                              </div>
                                              <TextField
                                                id="outlined-basic-minutes"
                                                type="number"
                                                size="small"
                                                placeholder="Min"
                                                name="paceUp"
                                                value={formatWithLeadingZeros(
                                                  Math.floor(item?.paceUp / 60),
                                                )}
                                                onChange={(e) =>
                                                  handleMinutesChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  )
                                                }
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                  readOnly: true,
                                                }}
                                                sx={{
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& input": {
                                                    textAlign: "center",
                                                    padding: "0px",
                                                  },
                                                  width: "100%",
                                                }}
                                              />
                                              <div className="fs-6 fw-semibold ms-1">
                                                :
                                              </div>
                                              <TextField
                                                id="outlined-basic-seconds"
                                                type="number"
                                                size="small"
                                                placeholder="Sec"
                                                name="paceUp"
                                                value={formatWithLeadingZeros(
                                                  item?.paceUp % 60,
                                                )}
                                                onChange={(e) =>
                                                  handleSecondsChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  )
                                                }
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                  readOnly: true,
                                                }}
                                                sx={{
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& input": {
                                                    textAlign: "center",
                                                    padding: "0px",
                                                  },
                                                  width: "100%",
                                                  marginRight: 1,
                                                }}
                                              />
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",

                                          marginTop: "5px",
                                          "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                            {
                                              width: "0px !important",
                                              padding: "9px 0px !important",
                                            },
                                          "& .css-1nuss9t": {
                                            width: "0px !important",
                                            padding: "9px 0px !important",
                                          },

                                          width: "100%",
                                        }}
                                      />
                                    </div>
                                    ) : (
                                    <div
                                      className={`col-12 col-md-2 col-lg-1 pe-0 py-1`}
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        variant="outlined"
                                        label={getPaceText(item?.pace_type)}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingLeft: "0px",
                                            paddingRight: "0px",

                                            justifyContent: "center",
                                          },
                                          readOnly: true,
                                          endAdornment: (
                                            <InputAdornment
                                              position="end"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <TextField
                                                id="outlined-basic-minutes"
                                                type="number"
                                                size="small"
                                                placeholder="Min"
                                                name="pace"
                                                value={formatWithLeadingZeros(
                                                  Math.floor(item?.pace / 60),
                                                )}
                                                onChange={(e) =>
                                                  handleMinutesChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  )
                                                }
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                  readOnly: true,
                                                }}
                                                sx={{
                                                  "& fieldset": {
                                                    border: "none",
                                                  },

                                                  "& input": {
                                                    textAlign: "center",
                                                    padding: "0px",
                                                  },
                                                  width: "100%",
                                                }}
                                              />
                                              <div className="fs-6 fw-semibold ms-1 ">
                                                :
                                              </div>

                                              <TextField
                                                id="outlined-basic-seconds"
                                                type="number"
                                                size="small"
                                                placeholder="Sec"
                                                name="pace"
                                                value={formatWithLeadingZeros(
                                                  item?.pace % 60,
                                                )}
                                                onChange={(e) =>
                                                  handleSecondsChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  )
                                                }
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                  readOnly: true,
                                                }}
                                                sx={{
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& input": {
                                                    textAlign: "center",
                                                    padding: "0px",
                                                  },
                                                  width: "100%",
                                                }}
                                              />
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                            {
                                              width: "0px !important",
                                              padding: "9px 0px !important",
                                            },
                                          "& .css-1nuss9t": {
                                            width: "0px !important",
                                            padding: "9px 0px !important",
                                          },
                                          width: "100%",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                    )
                                  </>
                                )}
                                {data.parameters.includes("Pace") && (
                                  <>
                                    <div
                                      className={`col-12 col-md-3 ${
                                        item?.race_type == "t"
                                          ? "col-lg-3"
                                          : "col-lg-2"
                                      } pe-0 py-1`}
                                    >
                                      <FormControl
                                        fullWidth
                                        className="py-1"
                                        readOnly={true}
                                      >
                                        <InputLabel
                                          className="set-Type-lable"
                                          sx={{ fontSize: "14px" }}
                                          id="demo-simple-select-label"
                                        >
                                          Type
                                        </InputLabel>
                                        <Select
                                          className="set-Type-value"
                                          id="select-option"
                                          variant="outlined"
                                          size="small"
                                          name="race_type"
                                          value={item?.race_type}
                                          label="Type"
                                          readOnly={true}
                                          inputProps={{
                                            style: {
                                              padding: 0,
                                            },
                                            readOnly: true,
                                          }}
                                          onChange={(e) => {
                                            handleChangeVdotDistance(
                                              e,
                                              mainindex,
                                              index1,
                                            );
                                          }}
                                          sx={{
                                            width: "100%",
                                            // "& legend": {
                                            //   display: "none",
                                            // },
                                            // "& fieldset": {
                                            //   top: 0,
                                            // },
                                            fontSize: "13px",

                                            "& .MuiOutlinedInput-input": {
                                              paddingLeft: 1,
                                            },
                                          }}
                                        >
                                          <MenuItem value="el">
                                            Easy/Long
                                          </MenuItem>
                                          <MenuItem value="c">
                                            Compromised
                                          </MenuItem>
                                          <MenuItem value="t">
                                            Threshold/Tempo
                                          </MenuItem>
                                          <MenuItem value="i">
                                            Interval
                                          </MenuItem>
                                          <MenuItem value="r">
                                            Repitition
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </div>
                                    <div
                                      className={`col-12 col-md-3 col-lg-2 pe-0 py-1`}
                                    >
                                      <TextField
                                        sx={{
                                          borderRadius: "5px",
                                          paddingRight: 0,
                                          width: "100%",
                                          marginTop: "5px",
                                        }}
                                        size="small"
                                        id="custom-input"
                                        variant="outlined"
                                        readOnly={true}
                                        placeholder={"Distance"}
                                        name="distance"
                                        label="Distance"
                                        value={item?.distance}
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        type="number"
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingRight: 0,
                                          },
                                          readOnly: true,
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="distanceType"
                                                value={item?.distanceType}
                                                label="Weight Type"
                                                onChange={(e) => {
                                                  handleChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  );
                                                }}
                                                readOnly={true}
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": {
                                                    top: 0,
                                                  },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                }}
                                              >
                                                <MenuItem value="m">
                                                  Meter
                                                </MenuItem>
                                                <MenuItem value="km">
                                                  KM
                                                </MenuItem>
                                                <MenuItem value="mi">
                                                  Mile
                                                </MenuItem>
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={`col-12 col-md-2 col-lg-2 pe-0 py-1`}
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        variant="outlined"
                                        label={getPaceTextinPaces(
                                          item?.distanceType,
                                        )}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingLeft: "0px",
                                            paddingRight: "0px",
                                            justifyContent: "center",
                                          },
                                          readOnly: true,
                                          endAdornment: (
                                            <InputAdornment
                                              position="end"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <TextField
                                                id="outlined-basic-minutes"
                                                type="number"
                                                size="small"
                                                placeholder="Min"
                                                name="pace"
                                                readOnly="true"
                                                value={formatWithLeadingZeros(
                                                  Math.floor(item?.pace / 60),
                                                )}
                                                onChange={(e) =>
                                                  handleMinutesChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  )
                                                }
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                  readOnly: true,
                                                }}
                                                sx={{
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& input": {
                                                    textAlign: "center",
                                                    padding: "0px",
                                                  },
                                                  width: "100%",
                                                }}
                                              />
                                              <div className="fs-6 fw-semibold ms-1 ">
                                                :
                                              </div>
                                              <TextField
                                                id="outlined-basic-seconds"
                                                type="number"
                                                size="small"
                                                placeholder="Sec"
                                                name="pace"
                                                value={formatWithLeadingZeros(
                                                  item?.pace % 60,
                                                )}
                                                onChange={(e) =>
                                                  handleSecondsChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  )
                                                }
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                  readOnly: true,
                                                }}
                                                sx={{
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& input": {
                                                    textAlign: "center",
                                                    padding: "0px",
                                                  },
                                                  width: "100%",
                                                }}
                                              />
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                            {
                                              width: "0px !important",
                                              padding: "9px 0px !important",
                                            },
                                          "& .css-1nuss9t": {
                                            width: "0px !important",
                                            padding: "9px 0px !important",
                                          },
                                          width: "100%",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>

                                    <div
                                      style={{
                                        position: "absolute",
                                        bottom: "4px",
                                        left: "52px",
                                      }}
                                    >
                                      <Typography
                                        variant="subtitle2"
                                        sx={{
                                          opacity: 0.6,
                                          fontWeight: "600",
                                          fontSize: "12px",
                                        }}
                                      >{` @ Speed ${getKmhrForPace(
                                        item?.distance,
                                        item?.pace,
                                        item?.distanceType,
                                      )} km/hr or ${getMihrForPace(
                                        item?.distance,
                                        item?.pace,
                                        item?.distanceType,
                                      )} mi/hr`}</Typography>
                                    </div>
                                  </>
                                )}
                                {data.parameters.includes("Distance") && (
                                  <div
                                    className={`col-12 col-md-3 col-lg-2 pe-0 py-1`}
                                  >
                                    <TextField
                                      sx={{
                                        borderRadius: "5px",
                                        paddingRight: 0,
                                        width: "100%",
                                        marginTop: "5px",
                                      }}
                                      size="small"
                                      id="custom-input"
                                      variant="outlined"
                                      placeholder={"Distance"}
                                      name="distance"
                                      label="Distance"
                                      value={item?.distance}
                                      onChange={(e) => {
                                        handleChange(e, mainindex, index1);
                                      }}
                                      type="number"
                                      InputLabelProps={{
                                        className: "textfiels-input-label",
                                        shrink: true,
                                        style: { fontSize: "14px" },
                                      }}
                                      InputProps={{
                                        className: "textfiels-input-value",
                                        style: {
                                          fontSize: "13px",
                                          paddingRight: 0,
                                        },
                                        readOnly: true,
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <Select
                                              id="select-option"
                                              variant="outlined"
                                              size="small"
                                              name="distanceType"
                                              value={item?.distanceType}
                                              label="Weight Type"
                                              readOnly
                                              onChange={(e) => {
                                                handleChange(
                                                  e,
                                                  mainindex,
                                                  index1,
                                                );
                                              }}
                                              sx={{
                                                "& legend": {
                                                  display: "none",
                                                },
                                                "& fieldset": {
                                                  top: 0,
                                                },
                                                fontSize: "13px",
                                                border: "none",
                                                "& fieldset": {
                                                  border: "none",
                                                },
                                              }}
                                            >
                                              <MenuItem value="m">
                                                Meter
                                              </MenuItem>
                                              <MenuItem value="km">KM</MenuItem>
                                              <MenuItem value="mi">
                                                Mile
                                              </MenuItem>
                                            </Select>
                                          </InputAdornment>
                                        ),
                                      }}
                                    />
                                  </div>
                                )}
                                {(data.parameters.includes("Duration/Pace") ||
                                  data.parameters.includes("Time")) && (
                                  <div
                                    className={`col-12 col-md-3 col-lg-2 pe-0 py-1`}
                                  >
                                    <TextField
                                      id="outlined-basic"
                                      size="small"
                                      variant="outlined"
                                      readOnly={true}
                                      placeholder="0"
                                      type="number"
                                      value={item?.time}
                                      name="time"
                                      onChange={(e) => {
                                        handleChange(e, mainindex, index1);
                                      }}
                                      InputLabelProps={{
                                        className: "textfiels-input-label",
                                        shrink: true,
                                        style: { fontSize: "14px" },
                                      }}
                                      label={
                                        data.parameters.includes(
                                          "Duration/Pace",
                                        )
                                          ? "Duration/Pace"
                                          : "Time"
                                      }
                                      InputProps={{
                                        className: "textfiels-input-value",
                                        style: {
                                          fontSize: "13px",
                                          paddingRight: 0,
                                        },
                                        readOnly: true,
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <Select
                                              id="select-option"
                                              variant="outlined"
                                              size="small"
                                              name="timeType"
                                              value={item?.timeType}
                                              label="Weight Type"
                                              inputProps={{
                                                style: {
                                                  padding: 0,
                                                },
                                              }}
                                              readOnly={true}
                                              onChange={(e) => {
                                                handleChange(
                                                  e,
                                                  mainindex,
                                                  index1,
                                                );
                                              }}
                                              sx={{
                                                "& legend": {
                                                  display: "none",
                                                },
                                                "& fieldset": {
                                                  top: 0,
                                                },
                                                fontSize: "13px",
                                                border: "none",
                                                "& fieldset": {
                                                  border: "none",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                  padding: 0,
                                                },
                                              }}
                                            >
                                              <MenuItem value="sec">
                                                sec
                                              </MenuItem>
                                              <MenuItem value="min">
                                                min
                                              </MenuItem>
                                            </Select>
                                          </InputAdornment>
                                        ),
                                      }}
                                      sx={{
                                        borderRadius: "5px",
                                        fontSize: "13px",
                                        width: "100%",
                                        marginTop: "5px",
                                      }}
                                    />
                                  </div>
                                )}

                                {data.parameters.includes("Reps") && (
                                  <div className="col-12 col-md-2 col-lg-1 pe-0 py-1">
                                    <TextField
                                      id="outlined-basic"
                                      size="small"
                                      variant="outlined"
                                      placeholder="Reps"
                                      type="number"
                                      readOnly="true"
                                      label="Reps"
                                      value={item?.reps}
                                      name="reps"
                                      onChange={(e) => {
                                        handleChange(e, mainindex, index1);
                                      }}
                                      InputLabelProps={{
                                        className: "textfiels-input-label",
                                        shrink: true,
                                        style: { fontSize: "14px" },
                                      }}
                                      InputProps={{
                                        className: "textfiels-input-value",
                                        style: { fontSize: "13px" },
                                        readOnly: true,
                                      }}
                                      sx={{
                                        borderRadius: "5px",
                                        fontSize: "13px",
                                        width: "100%",
                                        marginTop: "5px",
                                      }}
                                    />
                                  </div>
                                )}
                                {data.parameters.includes("Watts") && (
                                  <div className="col-12 col-md-2 col-lg-1 pe-0 py-1">
                                    <TextField
                                      id="outlined-basic"
                                      size="small"
                                      variant="outlined"
                                      placeholder="Watts"
                                      type="number"
                                      readOnly="true"
                                      label="Watts"
                                      value={item?.watts}
                                      name="watts"
                                      onChange={(e) => {
                                        handleChange(e, mainindex, index1);
                                      }}
                                      InputLabelProps={{
                                        className: "textfiels-input-label",
                                        shrink: true,
                                        style: { fontSize: "14px" },
                                      }}
                                      InputProps={{
                                        className: "textfiels-input-value",
                                        style: { fontSize: "13px" },
                                        readOnly: true,
                                      }}
                                      sx={{
                                        borderRadius: "5px",
                                        fontSize: "13px",
                                        width: "100%",
                                        marginTop: "5px",
                                      }}
                                    />
                                  </div>
                                )}
                                {data.parameters.includes("Height") && (
                                  <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                                    <TextField
                                      id="outlined-basic"
                                      size="small"
                                      variant="outlined"
                                      placeholder="0"
                                      type="number"
                                      value={item?.height}
                                      name="height"
                                      readOnly="true"
                                      onChange={(e) => {
                                        handleChange(e, mainindex, index1);
                                      }}
                                      InputLabelProps={{
                                        className: "textfiels-input-label",
                                        shrink: true,
                                        style: {
                                          fontSize: "14px",
                                        },
                                      }}
                                      label="Height"
                                      InputProps={{
                                        className: "textfiels-input-value",
                                        style: {
                                          fontSize: "13px",
                                          paddingRight: 0,
                                        },
                                        readOnly: true,
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <Select
                                              id="select-option"
                                              variant="outlined"
                                              size="small"
                                              name="height_unit"
                                              value={item?.height_unit}
                                              label="Height Type"
                                              inputProps={{
                                                style: {
                                                  padding: 0,
                                                },
                                              }}
                                              onChange={(e) => {
                                                handleChange(
                                                  e,
                                                  mainindex,
                                                  index1,
                                                );
                                              }}
                                              readOnly
                                              sx={{
                                                "& legend": {
                                                  display: "none",
                                                },
                                                "& fieldset": {
                                                  top: 0,
                                                },
                                                fontSize: "13px",
                                                border: "none",
                                                "& fieldset": {
                                                  border: "none",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                  padding: 0,
                                                },
                                              }}
                                            >
                                              <MenuItem value="cm">Cm</MenuItem>
                                              <MenuItem value="ft">
                                                Feet
                                              </MenuItem>
                                              <MenuItem value="inch">
                                                Inch
                                              </MenuItem>
                                            </Select>
                                          </InputAdornment>
                                        ),
                                      }}
                                      sx={{
                                        borderRadius: "5px",
                                        fontSize: "13px",
                                        width: "100%",
                                      }}
                                    />
                                  </div>
                                )}
                                {data.parameters.includes("Weight") && (
                                  <div className="col-12 col-md-4 col-lg-2 pe-0 py-1">
                                    <TextField
                                      sx={{
                                        borderRadius: "5px",
                                        paddingRight: 0,
                                        width: "100%",
                                        marginTop: "5px",
                                      }}
                                      size="small"
                                      id="custom-input"
                                      variant="outlined"
                                      readOnly="true"
                                      placeholder="Weight"
                                      name="weight"
                                      label="Weight"
                                      value={item.weight}
                                      onChange={(e) => {
                                        handleChange(e, mainindex, index1);
                                      }}
                                      type="number"
                                      InputLabelProps={{
                                        className: "textfiels-input-label",
                                        shrink: true,
                                        style: { fontSize: "14px" },
                                      }}
                                      InputProps={{
                                        className: "textfiels-input-value",
                                        style: {
                                          fontSize: "13px",
                                          paddingRight: 0,
                                        },
                                        readOnly: true,
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <Select
                                              id="select-option"
                                              variant="outlined"
                                              size="small"
                                              name="weightType"
                                              value={item?.weightType}
                                              label="Weight Type"
                                              readOnly={true}
                                              onChange={(e) => {
                                                handleChange(
                                                  e,
                                                  mainindex,
                                                  index1,
                                                );
                                              }}
                                              sx={{
                                                "& legend": {
                                                  display: "none",
                                                },
                                                "& fieldset": { top: 0 },
                                                fontSize: "13px",
                                                border: "none",
                                                "& fieldset": {
                                                  border: "none",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                  padding: 0,
                                                },
                                              }}
                                            >
                                              <MenuItem value="1rm">
                                                % 1RM
                                              </MenuItem>
                                              <MenuItem value="body_weight">
                                                % BW
                                              </MenuItem>
                                              <MenuItem value="kg">KG</MenuItem>
                                              <MenuItem value="lb">
                                                Pound
                                              </MenuItem>
                                              <MenuItem value="poods">
                                                Poods
                                              </MenuItem>
                                            </Select>
                                          </InputAdornment>
                                        ),
                                      }}
                                    />
                                  </div>
                                )}
                                {data.parameters.includes(
                                  "Distance/Calories",
                                ) && (
                                  <div className="col-12 col-md-3 col-lg-2 pe-0 py-1">
                                    <TextField
                                      sx={{
                                        borderRadius: "5px",
                                        paddingRight: 0,
                                        width: "100%",
                                        marginTop: "5px",
                                      }}
                                      readOnly
                                      size="small"
                                      id="custom-input"
                                      variant="outlined"
                                      placeholder={
                                        item?.distanceType == "calories"
                                          ? "Calories"
                                          : "Distance"
                                      }
                                      name="distance"
                                      label="Distance/Calories"
                                      value={item?.distance}
                                      onChange={(e) => {
                                        handleChange(e, mainindex, index1);
                                      }}
                                      type="number"
                                      InputLabelProps={{
                                        className: "textfiels-input-label",
                                        shrink: true,
                                        style: { fontSize: "14px" },
                                      }}
                                      InputProps={{
                                        className: "textfiels-input-value",
                                        style: {
                                          fontSize: "13px",
                                          paddingRight: 0,
                                        },
                                        readOnly: true,
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <Select
                                              id="select-option"
                                              variant="outlined"
                                              size="small"
                                              name="distanceType"
                                              value={item?.distanceType}
                                              label="Weight Type"
                                              onChange={(e) => {
                                                handleChange(
                                                  e,
                                                  mainindex,
                                                  index1,
                                                );
                                              }}
                                              sx={{
                                                "& legend": {
                                                  display: "none",
                                                },
                                                "& fieldset": { top: 0 },
                                                fontSize: "13px",
                                                border: "none",
                                                "& fieldset": {
                                                  border: "none",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                  padding: 0,
                                                },
                                              }}
                                            >
                                              <MenuItem value="m">
                                                Meter
                                              </MenuItem>
                                              <MenuItem value="km">KM</MenuItem>
                                              <MenuItem value="mi">
                                                Mile
                                              </MenuItem>
                                              <MenuItem value="calories">
                                                Calories
                                              </MenuItem>
                                            </Select>
                                          </InputAdornment>
                                        ),
                                      }}
                                    />
                                  </div>
                                )}
                                {data.parameters.includes("%MHR") && (
                                  <div className="col-12 col-md-2 col-lg-1 pe-0 py-1">
                                    <TextField
                                      id="outlined-basic"
                                      size="small"
                                      variant="outlined"
                                      placeholder="%MHR"
                                      type="number"
                                      label="%MHR"
                                      value={item?.mhr}
                                      name="mhr"
                                      readOnly
                                      onChange={(e) => {
                                        handleChangeTempo(e, mainindex, index1);
                                      }}
                                      InputLabelProps={{
                                        className: "textfiels-input-label",
                                        shrink: true,
                                        style: { fontSize: "14px" },
                                      }}
                                      InputProps={{
                                        className: "textfiels-input-value",
                                        style: {
                                          fontSize: "13px",
                                        },
                                        readOnly: true,
                                      }}
                                      sx={{
                                        borderRadius: "5px",
                                        fontSize: "13px",
                                        width: "100%",
                                        marginTop: "5px",
                                        "& .MuiOutlinedInput-input": {
                                          padding: "8px 7px",
                                        },
                                      }}
                                    />
                                  </div>
                                )}
                                {data.parameters.includes("RPE") && (
                                  <div className="col-12 col-md-2 col-lg-1 pe-0 py-1">
                                    <TextField
                                      id="outlined-basic"
                                      size="small"
                                      variant="outlined"
                                      placeholder="RPE"
                                      label="RPE"
                                      value={item?.RPE}
                                      name="RPE"
                                      readOnly
                                      onChange={(e) => {
                                        handleChange(e, mainindex, index1);
                                      }}
                                      InputLabelProps={{
                                        className: "textfiels-input-label",
                                        shrink: true,
                                        style: { fontSize: "14px" },
                                      }}
                                      InputProps={{
                                        className: "textfiels-input-value",
                                        style: {
                                          fontSize: "13px",
                                        },
                                        readOnly: true,
                                      }}
                                      sx={{
                                        borderRadius: "5px",
                                        fontSize: "13px",
                                        width: "100%",
                                        marginTop: "5px",
                                        "& .MuiOutlinedInput-input": {
                                          padding: "8px 7px",
                                        },
                                      }}
                                    />
                                  </div>
                                )}
                                {data.parameters.includes("Tempo") && (
                                  <div className="col-12 col-md-2 col-lg-1 pe-0 py-1">
                                    <TextField
                                      id="outlined-basic"
                                      size="small"
                                      variant="outlined"
                                      placeholder="Tempo"
                                      type="number"
                                      label="Tempo"
                                      value={item?.tempo}
                                      name="tempo"
                                      readOnly={true}
                                      onChange={(e) => {
                                        handleChangeTempo(e, mainindex, index1);
                                      }}
                                      InputLabelProps={{
                                        className: "textfiels-input-label",
                                        shrink: true,
                                        style: { fontSize: "14px" },
                                      }}
                                      InputProps={{
                                        className: "textfiels-input-value",
                                        style: {
                                          fontSize: "13px",
                                        },
                                        readOnly: true,
                                      }}
                                      sx={{
                                        borderRadius: "5px",
                                        fontSize: "13px",
                                        width: "100%",
                                        marginTop: "5px",
                                        "& .MuiOutlinedInput-input": {
                                          padding: "8px 7px",
                                        },
                                      }}
                                    />
                                  </div>
                                )}
                                {data.parameters.includes("Rest") && (
                                  <div className="col-12 col-md-3 col-lg-2 pe-0 py-1">
                                    <TextField
                                      id="outlined-basic"
                                      size="small"
                                      variant="outlined"
                                      placeholder="0"
                                      type="number"
                                      value={item?.rest}
                                      readOnly="true"
                                      name="rest"
                                      onChange={(e) => {
                                        handleChange(e, mainindex, index1);
                                      }}
                                      InputLabelProps={{
                                        className: "textfiels-input-label",
                                        shrink: true,
                                        style: { fontSize: "14px" },
                                      }}
                                      label="Rest"
                                      InputProps={{
                                        className: "textfiels-input-value",
                                        style: {
                                          fontSize: "13px",
                                          paddingRight: 0,
                                        },
                                        readOnly: true,
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <Select
                                              id="select-option"
                                              variant="outlined"
                                              size="small"
                                              name="restType"
                                              value={item?.restType}
                                              label="Weight Type"
                                              inputProps={{
                                                style: {
                                                  padding: 0,
                                                },
                                              }}
                                              onChange={(e) => {
                                                handleChange(
                                                  e,
                                                  mainindex,
                                                  index1,
                                                );
                                              }}
                                              readOnly={true}
                                              sx={{
                                                "& legend": {
                                                  display: "none",
                                                },
                                                "& fieldset": {
                                                  top: 0,
                                                },
                                                fontSize: "13px",
                                                border: "none",
                                                "& fieldset": {
                                                  border: "none",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                  padding: 0,
                                                },
                                              }}
                                            >
                                              <MenuItem value="sec">
                                                sec
                                              </MenuItem>
                                              <MenuItem value="min">
                                                min
                                              </MenuItem>
                                            </Select>
                                          </InputAdornment>
                                        ),
                                      }}
                                      sx={{
                                        borderRadius: "5px",

                                        marginTop: "5px",
                                        fontSize: "13px",

                                        width: "100%",
                                      }}
                                    />
                                  </div>
                                )}
                                {data.parameters.includes("Vdot") && (
                                  <div>
                                    {item?.race_type == "el" ? (
                                      <Typography
                                        variant="subtitle2"
                                        sx={{
                                          opacity: 0.6,
                                          fontWeight: "600",
                                          fontSize: "12px",
                                        }}
                                      >{` @ Speed ${getKmhr(
                                        item?.pace,
                                        item?.pace_type,
                                      )} km/hr or ${getMihr(
                                        item?.pace,
                                        item?.pace_type,
                                      )} mi/hr -  ${getKmhr(
                                        item?.paceUp,
                                        item?.pace_type,
                                      )} km/hr or ${getMihr(
                                        item?.paceUp,
                                        item?.pace_type,
                                      )} mi/hr`}</Typography>
                                    ) : (
                                      <Typography
                                        variant="subtitle2"
                                        sx={{
                                          opacity: 0.6,
                                          fontWeight: "600",
                                          fontSize: "12px",
                                        }}
                                      >{` @ Speed ${getKmhr(
                                        item?.pace,
                                        item?.pace_type,
                                      )} km/hr or ${getMihr(
                                        item?.pace,
                                        item?.pace_type,
                                      )} mi/hr`}</Typography>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </Tooltip>
                        ))}
                    </Box>
                  </div>
                )}
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default WorkoutExercisesUIClient;
